import type { Middleware } from '@reduxjs/toolkit';
import { reduxWebsocket, WsExclusionGroups, WsPrefixes } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.mmPrefix;

const wsMmMiddleware: Middleware = reduxWebsocket({
  prefix,
  // MM and ES are the mutually-exclusive domain data channels — connecting one
  // disconnects the other. Assistant/auth have no group and stay connected.
  exclusionGroup: WsExclusionGroups.data,
  reconnectOnClose: true,
  dateSerializer: (date: Date) => date.toISOString(),
});

export default wsMmMiddleware;
